import React, { useEffect, useContext } from "react";
import LowStock from "./LowStock";
import StorePerformance from "./StorePerformance";
import DashboardOverview from "./DashboardOverview";
import TopSellingProducts from "./TopSellingProducts";
import RecentTransaction from "./RecentTransaction";
import DashboardSalesTrend from "./DashboardSalesTrend";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import { SupervisorCurrencyContext } from "../../context/SupervisorCurrencyProvider";
import HeatMap from "./HeatMapChart";

function DashboardContents() {
  const { fetchOnlyData } = SupervisorApi();
  const { currencyDetails, setCurrencyDetails } = useContext(
    SupervisorCurrencyContext
  );

  const { data } = useQuery({
    queryKey: ["currency"],
    queryFn: () => fetchOnlyData("dashboard/currency"),
    retry: 1,
    keepPreviousData: true,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    setCurrencyDetails(data?.currency?.symbol);
  }, [data, setCurrencyDetails]);

  return (
    <div className="flex flex-col lg:flex-row w-full">
      <div className="p-4 h-lvh flex-grow overflow-y-scroll pb-24 ">
        {/* Dashboard Summary */}
        <h2 className="text-3xl font-semibold mb-2">Dashboard</h2>

        <DashboardOverview currencyDetails={currencyDetails} />

        {/* Store Performance Overview */}
        <StorePerformance />
        <HeatMap />

        {/* Top Selling Products, put in their various components */}
        <TopSellingProducts currencyDetails={currencyDetails} />
        {/* Sales Trend */}
        <DashboardSalesTrend />
        {/* Recent Transactions */}
        <RecentTransaction currencyDetails={currencyDetails} />
      </div>
      <LowStock />
    </div>
  );
}

export default DashboardContents;
